import { PROPSTAT_INIT_LOADING, PROPSTAT_INIT_SUCCESS, PROPSTAT_INIT_FAIL, PROPSTAT_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import clone from 'clone'
import { extractMenu, extractMessages } from '@/utils/extract'

export const initialState = {
  init: 0,
  initErr: [],
  menu: {},
  propStat: {
    propStatId: {
      propStat: null,
      propStatDesc: null,
      perRev: null,
      allowCnvPol: null
    }
  }
}

const getters = {

}

const mutations = {
  [PROPSTAT_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [PROPSTAT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [PROPSTAT_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [PROPSTAT_COMMIT_KEY](state, data) {
    state.propStat.propStatId.propStat = data.propStat
    state.propStat.propStatId.propStatDesc = data.propStatDesc
    state.propStat.propStatId.perRev = data.perRev
    state.propStat.propStatId.allowCnvPol = data.allowCnvPol
    state.propStat.propStatId.tranMode = data.tranMode
  }
}

const actions = {
  async propStatManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.propStatManagement
    commit(PROPSTAT_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(PROPSTAT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(PROPSTAT_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
